import React, { FC } from 'react'
import { fieldsForSocket, orderEditSelectors, orderEditSlice } from 'Pages/registratorCabinet'
import { useAppDispatch } from 'Src/hooks'
import { useHistory } from 'react-router-dom'
import { FrontUrls } from 'Constants/FrontUrls'
import { BtnComponent, Heading, Indent, Text, TextRowComponent, TextType } from 'LibNeo'
import { useSelector } from 'react-redux'
import { SPACE_SYMBOL } from 'Constants/Global'

interface ComponentProps {
	close: () => void
}

const actions = {
	clearSocketId: orderEditSlice.actions.clearSocketId,
}

export const NewRequestModal: FC<ComponentProps> = ({ close }) => {
	const data = useSelector(orderEditSelectors.getSocketRequest)
	const { clearSocketId } = useAppDispatch(actions)
	const history = useHistory()
	const onButtonClick = () => {
		close()
		clearSocketId({ id: data.id })
		history.push(FrontUrls.cabinet_redesign.order_edit.replace(':id', String(data?.id)))
		window.location.reload()
	}
	return (
		<div>
			<Heading type="h4">Заявка создана</Heading>
			<Text type={TextType.BODY2} colorIndex={6}>
				<Indent top={20}>
					Ваш клиент заполнил информацию, принял оферту и согласился на обработку данных:
				</Indent>
			</Text>
			<Indent top={16}>
				{fieldsForSocket.map((field) => (
					<TextRowComponent title={field.name}>
						<Heading type="subtitle2">{data?.[field.field] || SPACE_SYMBOL}</Heading>
					</TextRowComponent>
				))}
			</Indent>
			<Indent top={30}>
				<BtnComponent block title="Перейти к заявке" onClick={onButtonClick} />
			</Indent>
		</div>
	)
}
